import mutations from './supervisorImport.mutations'
import actions from './supervisorImport.actions'
import getters from './supervisorImport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
